<p-toast></p-toast>
<div class="breadcrumbs-wrapper">
  <div #breadcrumbsContainer class="container">
    <div #breadcrumbsWrapper class="breadcrumbs desktop">
      @if (!breadcrumbsRemoved) {
      <a class="back-link" (click)="goBack()">
        <img class="mr-8-px" src="././../../../../assets/images/icons/arrow_left_alt.svg" alt="back-icon">
        <span class="actual-text">Back</span>
        <img class="path-arrow" src="./../assets/images/icons/arrow-right-breadcrumbs.svg" alt="path-arrow">
      </a>
      <a  [routerLink]="'/'+vehicleTypeService?.currentVehicleType" [queryParams]="{ modificationId: selectedModificationService?.selectedModificationId }">
        <img src="././../../../../assets/images/icons/home_FILL1_wght400_GRAD0_opsz24 1.svg" alt="home-icon">
      </a>

      }
      @if (breadcrumbsRemoved) {
      <a class="back-link" (click)="goBack()">
        <img class="mr-8-px" src="././../../../../assets/images/icons/arrow_left_alt.svg" alt="back-icon">
        <span class="actual-text">Back</span>
        <img class="path-arrow" src="./../assets/images/icons/arrow-right-breadcrumbs.svg" alt="path-arrow">
      </a>
      <a pRipple class="breadcrumbs-menu-btn" (click)="menu.toggle($event)">
        <img src="./../../../../assets/images/icons/dots.svg" alt="home-icon">
      </a>
      }
      <p-menu #menu [model]="breadcrumbMenuItems" [popup]="true"></p-menu>
      <img class="path-arrow" src="./../assets/images/icons/arrow-right-breadcrumbs.svg" alt="path-arrow">
      @for (item of breadcrumbsService.breadcrumbs; track item; let last = $last) {
      <a class="breadcrumb-link" [routerLink]="[item.routerLink]" [queryParams]="item.queryParams">
        <span class="actual-text">{{ item.label }}</span>
        @if (item.arrow && !last) {
        <img class="path-arrow" src="./../assets/images/icons/arrow-right-breadcrumbs.svg" alt="path-arrow">
        }
      </a>
      }
    </div>
  </div>
</div>
